
export default {
  head() {
    return {
      title: this.$i18n.t('Privacy & Cookie Statement'),
    }
  },
}
